export const ROUTE_MAIN_DATA = [
    {
        route: '/placardconfirmed',
        showStatusBar: false,
        viewChangeTemplate: 'placardconfirmed',
        viewchangeValue: 'placardconfirmed'
    },
    {
        route: '/dashboard',
        showStatusBar: false,
        viewChangeTemplate: 'dashboard',
        viewchangeValue: 'dashboard'
    },
    {
        route: '/placardpending',
        showStatusBar: false,
        viewChangeTemplate: 'placardpending',
        viewchangeValue: 'placardpending'
    },
    {
        route: '/placardlocation',
        showStatusBar: false,
        viewChangeTemplate: 'placardlocation',
        viewchangeValue: 'placardlocation'
    },
    {
        route: '/approve',
        showStatusBar: false,
        viewChangeTemplate: 'approve',
        viewchangeValue: 'approve'
    },
    {
        route: '/approveconfirmed',
        showStatusBar: false,
        viewChangeTemplate: 'approveconfirmed',
        viewchangeValue: 'approveconfirmed'
    },
    {
        route: '/dashboard',
        showStatusBar: false,
        viewChangeTemplate: 'dashboard',
        viewchangeValue: 'dashboard'
    }
];

export const ROUTE_INTERNAL_URL = [
    {
        url: '/placardconfirmed',
        showStatusBar: false,
        viewChangeTemplate: 'placardconfirmed',
        viewchangeValue: 'placardconfirmed'
    },
]

export const URL_EXTERNAL = ['placardconfirmed', 'placardpending', 'placardlocation', 'approve', 'dashboard', 'approveconfirmed'];